module.exports = __webpack_public_path__ + "img/ic_excel.96fd2e0e.svg";